import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { useLocation, useParams } from 'react-router-dom';
import API_URL from '../../Api'
import moment from 'moment';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import no_image from "../../assets/images/no-image.png";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import Select from 'react-select'
import { renderSafeHtml } from '../utils/renderSafeHtml';
import RichText from '../RichText/RichText';

export default function DetailEvent() {
    const { code } = useParams();
    const location = useLocation();

    const [detailEvent, setDetailEvent] = useState([]);
    const [leadSource, setLeadSource] = useState([]);
    const [city, setCity] = useState([]);
    const [provinsi, setProvinsi] = useState([]);
    const [jenjang, setJenjang] = useState([]);
    const [sekolah, setSekolah] = useState([]);
    const [nama, setNama] = useState('');
    const [email, setEmail] = useState('');
    const [noWa, setNoWa] = useState('');
    const [kodekabkota, setKodekabkota] = useState(0);
    const [idProvinsi, setIdProvinsi] = useState('');
    const [codeJenjang, setCodeJenjang] = useState('');
    const [file, setFile] = useState('');
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [schoolNameManual, setSchoolNameManual] = useState('');
    const [kodeLeadsource, setKodeLeadsource] = useState('');
    const [isAlumni, setIsAlumni] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const [isMember, setIsMember] = useState(false);
    const [imgLoaded, setImgLoaded] = useState(false);
    const [arrayNotes, setArrayNotes] = useState([
        { "kode_leadsource": "" },
        { "tahun_angkatan": "" },
        { "alamat": "" },
        { "keterangan": "" }
    ]);
    const [formErrors, setFormErrors] = useState({});

    const getEventDetail = () => {
        API_URL.baseUrl.get('event/event-by-slug/' + code)
            .then(res => res.data)
            .then(data => {
                setDetailEvent(data.data);
                setCity(data.data.event_lokasi);
                setKodekabkota(
                    data.data.event_lokasi.length === 1
                        ? data.data.event_lokasi[0].kabupaten.id_kabkota
                        : 0
                );
            });
    };

    const getLeadsSource = () => {
        API_URL.baseUrl.get('master/lead-source')
            .then(res => res.data)
            .then(data => setLeadSource(data.data));
    };

    const getProvinsi = () => {
        API_URL.baseUrl.get('master/provinces')
            .then(res => res.data)
            .then(data => setProvinsi(data.data));
    };

    const getJenjang = () => {
        API_URL.baseUrl.get('master/jenjang')
            .then(res => res.data)
            .then(data => setJenjang(data.data));
    };

    const getSekolah = () => {
        if (!idProvinsi || idProvinsi === "0" || !codeJenjang || codeJenjang === "0") {
            setSekolah([]);
            setSelectedSchool(null);
            return;
        }

        API_URL.baseUrl.get(`sekolah-indonesia?province_id=${idProvinsi}&jenjang=${codeJenjang}`)
            .then(res => res.data)
            .then(data => {
                const formattedOptions = data.data.map(item => ({
                    value: item.kode_sekolah,
                    label: item.nama_sekolah
                }));
                setSekolah(formattedOptions);
            });
    };

    const getDefaultCodeLeadsSource = () => {
        const searchParams = new URLSearchParams(location.search);
        const source = searchParams.get('source');
        if (source === 'LS013') {
            setKodeLeadsource(source);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "nama") setNama(value);
        if (name === "email") setEmail(value);
        if (name === "kodekabkota") setKodekabkota(value);
        if (name === "kode_leadsource") {
            if (value === 'alumni') {
                setIsAlumni(true);
                setKodeLeadsource(value);
                updateNotesArray(setArrayNotes, name, value);
            } else {
                setIsAlumni(false);
                setKodeLeadsource(value);
            }
        }
        if (name === "id_provinsi") setIdProvinsi(value);
        if (name === "code_jenjang") setCodeJenjang(value);
        if (name === "tahun_angkatan") updateNotesArray(setArrayNotes, name, value);
        if (name === "alamat") updateNotesArray(setArrayNotes, name, value);
        if (name === "keterangan") {
            setSchoolNameManual(value);
            updateNotesArray(setArrayNotes, name, value);
        }

        // Clear related error on change
        setFormErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const updateNotesArray = (setArrayNotes, name, value) => {
        setArrayNotes((prev) => {
            const exist = prev.findIndex((item) => item[name] !== undefined);

            if (exist !== -1) {
                const updated = [...prev];
                updated[exist] = { ...updated[exist], [name]: value }; // ⬅ merge, bukan replace
                return updated;
            }

            return [...prev, { [name]: value }];
        });
    };

    const handleChangeSekolah = (e) => {
        const { name, value } = e.target;

        if (name === "id_provinsi") {
            setIdProvinsi(value);
            setSelectedSchool(null);
        }
        if (name === "code_jenjang") {
            setCodeJenjang(value);
            setSelectedSchool(null);
        }

        setFormErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const handleChangeEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
        API_URL.baseUrl.get('members/check-member/' + value)
            .then(res => {
                if (res.data.data != null) {
                    setIsMember(true);
                } else {
                    setIsMember(false);
                }
            });
        setFormErrors(prev => ({ ...prev, email: undefined }));
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setFormErrors(prev => ({ ...prev, file: undefined }));
    }

    const handleSelectSekolah = (val) => {
        setSelectedSchool(val);
    };

    // ---- FORM VALIDATION LOGIC ----
    function validateForm() {
        let errors = {};
        // For event with offline/hybrid, city required
        if (
            (detailEvent.category_event === 'Offline' || detailEvent.category_event === 'Hybrid') &&
            city.length > 1 &&
            (!kodekabkota || kodekabkota === "0" || kodekabkota === 0)
        ) {
            errors.kodekabkota = "Kota wajib diisi";
        }

        // Sumber Informasi
        if (kodeLeadsource !== 'LS013' && (!kodeLeadsource || kodeLeadsource === "0")) {
            errors.kode_leadsource = "Sumber Informasi wajib diisi";
        }

        // Is Alumni
        if (isAlumni) {
            // Validate tahun angkatan exists and not "0"
            const tahunAngkatanObj = arrayNotes.find(item => item.tahun_angkatan !== undefined);
            if (!tahunAngkatanObj || !tahunAngkatanObj.tahun_angkatan || tahunAngkatanObj.tahun_angkatan === "0") {
                errors.tahun_angkatan = "Tahun Angkatan wajib diisi";
            }
        }

        // Nama
        if (!nama || nama.trim() === "") {
            errors.nama = "Nama Lengkap wajib diisi";
        }

        // No WhatsApp (basic: exist and valid format)
        if (!noWa || noWa.trim() === "") {
            errors.no_wa = "No. WhatsApp wajib diisi";
        } else if (!/^\+?\d{7,20}$/.test(noWa)) {
            errors.no_wa = "No. WhatsApp tidak valid";
        }

        // Email
        if (!email || email.trim() === "") {
            errors.email = "Email wajib diisi";
        } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            errors.email = "Email tidak valid";
        }

        // File pendukung (optional, only if required by event)
        if (detailEvent.status_file === 1 && !file) {
            errors.file = "File pendukung wajib diunggah";
        }

        // Provinsi
        if (!idProvinsi || idProvinsi === "0") {
            errors.id_provinsi = "Provinsi wajib diisi";
        }

        // Jenjang
        if (!codeJenjang || codeJenjang === "0") {
            errors.code_jenjang = "Jenjang Pendidikan wajib diisi";
        }

        // Alamat (for certain event)
        if (detailEvent.id === 386) {
            const alamatObj = arrayNotes.find(item => item.alamat !== undefined);
            if (!alamatObj || !alamatObj.alamat || alamatObj.alamat.trim() === "") {
                errors.alamat = "Alamat Lengkap wajib diisi";
            }
        }
        return errors;
    }

    const sendRow = () => {
        // --- FORM VALIDATION ---
        const errors = validateForm();
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            // Scroll to first error if exists
            const field = Object.keys(errors)[0];
            const el = document.getElementsByName(field)[0];
            if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });

            // Show error swal
            Swal.fire({
                title: 'Gagal',
                icon: 'error',
                confirmButtonColor: '#c00019',
                text: errors[field] || 'Harap lengkapi form yang wajib diisi.',
            });
            setBtnDisable(false);
            return;
        }

        setBtnDisable(true);
        let formData = new FormData();
        formData.append('id_konten', detailEvent.id);
        formData.append('id_kabkota', kodekabkota);
        formData.append('code_leads', kodeLeadsource);
        if (isMember) {
            formData.append('member', true);
        }
        formData.append('name', nama);
        formData.append('email', email);
        formData.append('phone', noWa.replace('+', ''));
        formData.append('sekolah', selectedSchool?.value || '');
        formData.append('province_id', idProvinsi);
        formData.append('code_jenjang', codeJenjang);
        formData.append('file', file);
        formData.append('keterangan', JSON.stringify(arrayNotes));

        API_URL.eventUrl.post('register', formData)
            .then(response => {
                if (detailEvent.status_payment === 1 && !isMember) {
                    window.snap.pay(response.data.data, {
                        onSuccess: () => window.location.reload(false),
                        onPending: () => window.location.reload(false),
                        onError: (result) => console.log(result),
                        onClose: () => console.log('window close'),
                    });
                }
                setBtnDisable(false);
                setNama('');
                setEmail('');
                setNoWa('');
                Swal.fire({
                    title: 'Sukses',
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                    text: `Selamat kamu sudah berhasil terdaftar di event ${detailEvent.name}, cek chat whatsapp kamu untuk info selanjutnya`,
                });
            })
            .catch(error => {
                console.log(error);
                setBtnDisable(false);
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    text: 'Terjadi kesalahan, cek kembali input anda',
                });
            });
    }

    useEffect(() => {
        getEventDetail();
        getLeadsSource();
        getProvinsi();
        getJenjang();
        getSekolah();
        getDefaultCodeLeadsSource();
    }, [code, idProvinsi, codeJenjang]);

    const years = Array.from({ length: 26 }, (_, i) => 2000 + i);

    const eventCategory = detailEvent?.category_event || '';
    const eventCategoryClass = eventCategory ? eventCategory.toLowerCase() : 'default';

    function EllipsisText({ text, maxWords }) {
        const truncate = (str) => {
            const words = str.split(" ");
            return words.length > maxWords ? words.slice(0, maxWords).join(" ") + "..." : str;
        };
        return (
            <span title={text} style={{ cursor: "pointer" }}>
                {truncate(text)}
            </span>
        );
    };

    return (
        <section className="section bg-detail detail-page-enter" id="home">
            <Container className="detail-layout">
                <Row className='position-relative detail-hero-row'>
                    <Col lg="12" className="detail-banner-panel">
                        <div style={{ position: "relative", display: "inline-block", width: "100%" }} className='title-box'>
                            {detailEvent.image !== null ? (
                                <img
                                    className="img-fluid detail-banner-image"
                                    style={{ borderRadius: "30px", width: "100%" }}
                                    src={detailEvent.image}
                                    onLoad={() => setImgLoaded(true)}
                                    onError={() => setImgLoaded(true)}
                                />
                            ) : (
                                <img
                                    className="img-fluid mt-5 detail-banner-image"
                                    style={{ borderRadius: "30px", width: "100%" }}
                                    src={no_image}
                                    onLoad={() => setImgLoaded(true)}
                                />
                            )}

                            {imgLoaded && (
                                <div className="event-label-d">
                                    <ul>
                                        <li className='text'>
                                            {moment(detailEvent?.event_lokasi?.[0]?.time_event || detailEvent?.start_date).format(
                                                "dddd"
                                            )}
                                        </li>
                                        <li className="date">
                                            {moment(
                                                detailEvent?.event_lokasi?.[0]?.time_event || detailEvent.start_date
                                            ).format("DD")}
                                        </li>
                                        <li className="month">
                                            {moment(
                                                detailEvent?.event_lokasi?.[0]?.time_event || detailEvent.start_date
                                            ).format("MMM")}
                                        </li>
                                        <li className="text year">
                                            {moment(
                                                detailEvent?.event_lokasi?.[0]?.time_event || detailEvent.start_date
                                            ).year()}
                                        </li>
                                    </ul>
                                </div>
                            )}

                            {/* 👇 Always bottom-left */}
                            {/* <div className="banner-label-d">
                        <ul>
                        <li>{detailEvent?.event_lokasi?.[0]?.place || ""}</li>
                        <li>
                            <EllipsisText
                                text={detailEvent?.event_lokasi?.[0]?.alamat || ""}
                                maxWords={6}
                            />
                        </li>
                        <li>
                          {detailEvent?.event_lokasi?.[0]?.time_event
                            ? `${moment(detailEvent.event_lokasi[0].time_event).format("HH:mm")} - ${
                                detailEvent.code_event === "EV00000285"
                                  ? `${moment(detailEvent.event_lokasi[0].time_event).add(4, "hours").format("HH:mm")} WIB`
                                  : `${moment(detailEvent.event_lokasi[0].time_event).add(1, "hours").format("HH:mm")} WITA`
                              }`
                            : ""}
                        </li>
                        </ul>
                    </div> */}
                        </div>
                    </Col>
                </Row>
                <Row className='justify-content-center mt-3 detail-location-row'>
                    {
                        city.length > 0 ?
                            city.map((kota) => (
                                <Col key={kota.id} lg='6' className='mb-2'>
                                    <Card style={{ borderRadius: "30px" }}>
                                        <CardBody>
                                            <Row>
                                                <Col sm='1' lg='1'>
                                                    <h5><FontAwesomeIcon icon={faLocationDot} /></h5>
                                                </Col>
                                                <Col sm='11' lg='11'>
                                                    <h5>{kota.kabupaten.nama_kabkota}</h5>
                                                    <h5>{kota.alamat}</h5>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                            :
                            ''
                    }
                </Row>
                <Row className="detail-main-row">
                    <Col lg='8' className="detail-description-panel">
                        <div className="detail-description-card">
                            <div className="detail-description-header">
                                <div>
                                    <span className="detail-description-eyebrow">Informasi Event</span>
                                    <h2>Deskripsi Event</h2>
                                </div>
                                {eventCategory && (
                                    <span className={`detail-event-type-badge ${eventCategoryClass}`}>
                                        {eventCategory}
                                    </span>
                                )}
                            </div>
                            <RichText html={detailEvent.description} />
                        </div>
                        {
                            detailEvent.category_event == 'Online' || detailEvent.category_event == 'Hybrid' ?
                                <>
                                    <h2 className='mt-5'>Link Online Meeting</h2>
                                    <div>
                                        <h4>{detailEvent.zoom_link}</h4>
                                    </div>
                                </>
                                :
                                ''
                        }
                    </Col>
                    <Col
                        lg='4'
                        className='mt-5 d-flex flex-column align-items-center detail-register-panel'
                        style={{ borderRadius: '25px', boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.07)' }}
                    >
                        <div style={{ width: '100%', maxWidth: 380 }}>
                            <h2 className='mt-4 mb-3 text-center' style={{ color: '#c00019', fontWeight: 700 }}>
                                <span role="img" aria-label="register" style={{ fontSize: '1.5rem', marginRight: 8 }}>📝</span>
                                Register
                            </h2>
                            <form autoComplete="off" style={{ padding: '10px 18px 20px 18px' }}>
                                {(detailEvent.category_event === 'Offline' || detailEvent.category_event === 'Hybrid') && city.length > 1 && (
                                    <div className='form-group mb-4'>
                                        <label style={{ fontWeight: 500, marginBottom: 5 }}>Kota <span style={{ color: '#c00019' }}>*</span></label>
                                        <select
                                            className="form-control custom-dropdown"
                                            name="kodekabkota"
                                            onChange={handleChange}
                                            value={kodekabkota}
                                            style={formErrors.kodekabkota ? { borderColor: '#c00019' } : {}}
                                        >
                                            <option value='0' defaultValue>-- Pilih Kota --</option>
                                            {city.length > 0 &&
                                                city.map((kota) => (
                                                    <option key={kota.id} value={kota.kode_kabkota}>{kota.kabupaten.nama_kabkota}</option>
                                                ))
                                            }
                                        </select>
                                        {formErrors.kodekabkota && <small style={{ color: '#c00019' }}>{formErrors.kodekabkota}</small>}
                                    </div>
                                )}
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Nama Lengkap <span style={{ color: '#c00019' }}>*</span></label>
                                    <input
                                        type='text'
                                        placeholder="Nama Lengkap"
                                        className='form-control'
                                        name="nama"
                                        onChange={handleChange}
                                        value={nama}
                                        autoFocus
                                        required
                                        style={formErrors.nama ? { borderColor: '#c00019' } : {}}
                                    />
                                    {formErrors.nama && <small style={{ color: '#c00019' }}>{formErrors.nama}</small>}
                                </div>
                                <div className='form-group mb-4'>
                                    <label htmlFor="no_wa" style={{ fontWeight: 500, marginBottom: 5, display: 'block' }}>
                                        No. WhatsApp <span style={{ color: '#c00019' }}>*</span>
                                    </label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <PhoneInput
                                            id="no_wa"
                                            defaultCountry='ID'
                                            international
                                            countryCallingCodeEditable={false}
                                            placeholder="Nomor WhatsApp aktif"
                                            value={noWa}
                                            name="no_wa"
                                            onChange={(value) => { setNoWa(value); setFormErrors(prev => ({ ...prev, no_wa: undefined })); }}
                                            inputComponent="input"
                                            style={{
                                                width: '100%',
                                                borderRadius: 5,
                                                border: formErrors.no_wa ? '1px solid #c00019' : '1px solid #ced4da',
                                                fontSize: 16,
                                                padding: '8px 12px',
                                                backgroundColor: '#fff',
                                            }}
                                        />
                                    </div>
                                    <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                        Pastikan nomor WhatsApp aktif dan menggunakan format internasional (+62)
                                    </small>
                                    {formErrors.no_wa && <small style={{ color: '#c00019' }}>{formErrors.no_wa}</small>}
                                </div>
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Email <span style={{ color: '#c00019' }}>*</span></label>
                                    <input
                                        placeholder="Email"
                                        className='form-control'
                                        name="email"
                                        onChange={handleChangeEmail}
                                        value={email}
                                        type="email"
                                        autoComplete="email"
                                        required
                                        style={formErrors.email ? { borderColor: '#c00019' } : {}}
                                    />
                                    {formErrors.email && <small style={{ color: '#c00019' }}>{formErrors.email}</small>}
                                </div>
                                {detailEvent.status_file === 1 && (
                                    <div className='form-group mb-4'>
                                        <label style={{ fontWeight: 500, marginBottom: 5 }}>File pendukung (CV, Surat, dll) </label>
                                        <input type='file' className='form-control' name="register_file" onChange={handleFileChange} style={formErrors.file ? { borderColor: '#c00019' } : {}} />
                                        {formErrors.file && <small style={{ color: '#c00019' }}>{formErrors.file}</small>}
                                    </div>
                                )}
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Provinsi Tempat Tinggal<span style={{ color: '#c00019' }}>*</span></label>
                                    <select
                                        className="form-control custom-dropdown"
                                        name="id_provinsi"
                                        value={idProvinsi}
                                        onChange={handleChangeSekolah}
                                        style={formErrors.id_provinsi ? { borderColor: '#c00019' } : {}}
                                    >
                                        <option value='0' defaultValue>-- Pilih Provinsi --</option>
                                        {provinsi.length > 0 &&
                                            provinsi.map((province) => (
                                                <option key={province.id} value={province.id}>{province.province_name}</option>
                                            ))
                                        }
                                    </select>
                                    {formErrors.id_provinsi && <small style={{ color: '#c00019' }}>{formErrors.id_provinsi}</small>}
                                </div>
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Jenjang Pendidikan Terakhir <span style={{ color: '#c00019' }}>*</span></label>
                                    <select
                                        className="form-control custom-dropdown"
                                        name="code_jenjang"
                                        value={codeJenjang}
                                        onChange={handleChangeSekolah}
                                        style={formErrors.code_jenjang ? { borderColor: '#c00019' } : {}}
                                    >
                                        <option value='0' defaultValue>-- Pilih Jenjang --</option>
                                        {jenjang.length > 0 &&
                                            jenjang.map((jenjang) => (
                                                <option key={jenjang.code_jenjang} value={jenjang.code_jenjang}>{jenjang.jenjang_pendidikan}</option>
                                            ))
                                        }
                                    </select>
                                    {formErrors.code_jenjang && <small style={{ color: '#c00019' }}>{formErrors.code_jenjang}</small>}
                                </div>
                                {detailEvent.id === 386 && (
                                    <div className='form-group mb-4'>
                                        <label style={{ fontWeight: 500, marginBottom: 5 }}>Alamat Lengkap</label>
                                        <textarea
                                            placeholder="Alamat"
                                            className='form-control'
                                            name="alamat"
                                            onChange={handleChange}
                                            rows={2}
                                            style={formErrors.alamat ? { borderColor: '#c00019' } : {}}
                                        />
                                        {formErrors.alamat && <small style={{ color: '#c00019' }}>{formErrors.alamat}</small>}
                                    </div>
                                )}
                                {kodeLeadsource !== 'LS013' && (
                                    <div className='form-group mb-4'>
                                        <label style={{ fontWeight: 500, marginBottom: 5 }}>Tau darimana tentang event ini? <span style={{ color: '#c00019' }}>*</span></label>
                                        <select
                                            className="form-control custom-dropdown"
                                            name="kode_leadsource"
                                            onChange={handleChange}
                                            value={kodeLeadsource}
                                            style={formErrors.kode_leadsource ? { borderColor: '#c00019' } : {}}
                                        >
                                            <option value='0' defaultValue>-- Pilih Sumber Informasi --</option>
                                            {leadSource != null &&
                                                leadSource.map((lead) => (
                                                    <option key={lead.id_leads_source} value={lead.code_leads_source}>{lead.source}</option>
                                                ))
                                            }
                                        </select>
                                        {formErrors.kode_leadsource && <small style={{ color: '#c00019' }}>{formErrors.kode_leadsource}</small>}
                                    </div>
                                )}
                                <div className="detail-optional-separator">
                                    <span>Opsional</span>
                                </div>
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Sekolah Asal</label>
                                    <Select
                                        placeholder={
                                            idProvinsi && idProvinsi !== "0" && codeJenjang && codeJenjang !== "0"
                                                ? "Pilih Sekolah..."
                                                : "Pilih provinsi dan jenjang dulu"
                                        }
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        isClearable={true}
                                        isDisabled={!idProvinsi || idProvinsi === "0" || !codeJenjang || codeJenjang === "0"}
                                        className="basic-single"
                                        onChange={handleSelectSekolah}
                                        value={selectedSchool}
                                        options={sekolah}
                                        noOptionsMessage={() => "Sekolah tidak ditemukan"}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 38,
                                                borderRadius: 5,
                                            })
                                        }}
                                    />
                                    <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                        Daftar sekolah dimuat berdasarkan Provinsi Tempat Tinggal dan Jenjang Pendidikan Terakhir.
                                    </small>
                                </div>
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Input Nama Sekolah</label>
                                    <input
                                        type='text'
                                        placeholder="Tulis nama sekolah jika tidak ada di daftar"
                                        className='form-control'
                                        name="keterangan"
                                        onChange={handleChange}
                                        value={schoolNameManual}
                                    />
                                    <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                        Isi bagian ini hanya jika sekolah asal tidak ditemukan pada pilihan di atas.
                                    </small>
                                </div>

                                {/* {isAlumni && (
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Tahun Angkatan<span style={{color:'#c00019'}}>*</span></label>
                                    <select
                                        className="form-control custom-dropdown"
                                        name="tahun_angkatan"
                                        onChange={handleChange}
                                        style={formErrors.tahun_angkatan ? {borderColor:'#c00019'} : {}}
                                    >
                                        <option value='0' defaultValue>-- Pilih Tahun Angkatan --</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                    {formErrors.tahun_angkatan && <small style={{ color:'#c00019'}}>{formErrors.tahun_angkatan}</small>}
                                </div>
                            )} */}
                                <div className='d-flex justify-content-end'>
                                    <button
                                        disabled={btnDisable}
                                        className="btn-custom"
                                        type='button'
                                        onClick={sendRow}
                                        style={{
                                            background: 'linear-gradient(90deg,#c00019 70%, #ff7675 100%)',
                                            color: '#fff',
                                            fontWeight: 600,
                                            border: 'none',
                                            borderRadius: '28px',
                                            minWidth: 130,
                                            padding: '10px 22px',
                                            boxShadow: btnDisable
                                                ? '0px 0px 0 #ccc'
                                                : '0 3px 18px 0 rgba(192,0,25,0.12)',
                                            transition: 'all .15s',
                                            opacity: btnDisable ? 0.65 : 1,
                                            cursor: btnDisable ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {btnDisable
                                            ? <span><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Registering...</span>
                                            : <span>Daftar Sekarang</span>
                                        }
                                    </button>
                                </div>
                            </form>
                            <div className="text-muted text-center" style={{ fontSize: '13px', marginTop: '18px', paddingBottom: '7px' }}>
                                <span>
                                    Data kamu aman dan tidak akan dibagikan kepada pihak manapun.<br />
                                    Butuh bantuan? <a href="https://wa.me/6282147778512" target="_blank" rel="noopener noreferrer" style={{ color: "#c00019", textDecoration: "underline" }}>Hubungi kami</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
